import './cell-dropdown.scss';
import { func, object } from 'prop-types';
import React from 'react';
import Input from '~/components/input';
const CellDropdown = ({ tab, onDropdownChange }) => {
    CellDropdown.propTypes = {
        tab: object.isRequired,
        onDropdownChange: func.isRequired,
    };
    return (React.createElement("div", { className: 'cell-dropdown' },
        React.createElement(Input, { type: 'select', defaultValue: 0, onChange: (e) => { onDropdownChange(e.target.value); } }, tab === null || tab === void 0 ? void 0 : tab.classifications.map((classification, index) => {
            const pageNum = classification.regions[0].pageNum || '';
            return (React.createElement("option", { key: `cell-dropdown-${index}`, value: index }, `${classification.name.split(':')[1].trim()} (p. ${pageNum})`));
        }))));
};
export default CellDropdown;
